import { transformConversationTransaction } from './conversation'
import {
  ConversationEducationContentModel,
  ConversationEducationDto,
  ConversationEducationModel,
  NewConversationEducationDto,
  NewConversationEducationModel,
} from '../types/conversation-education'
import { ConversationDto } from '../types/conversation'

const transformEducationDto = (
  education: ConversationEducationDto,
): ConversationEducationContentModel => {
  const { action, action_title, screen_title, type, url } = education

  return {
    action,
    actionTitle: action_title,
    screenTitle: screen_title,
    type,
    url,
  }
}

export const transformConversationEducationResponse = (
  conversation: ConversationDto,
): ConversationEducationModel => {
  const itemPhotoDto = conversation.transaction?.item_photo
    ? {
        url: conversation.transaction.item_photo.url,
        thumbnails: conversation.transaction.item_photo.thumbnails,
        isMain: conversation.transaction.item_photo.is_main,
        imageNo: conversation.transaction.item_photo.image_no,
      }
    : null

  return {
    transaction: conversation.transaction
      ? transformConversationTransaction(conversation.transaction)
      : null,
    item:
      conversation.transaction && conversation.transaction.item_id
        ? {
            id: conversation.transaction.item_id,
            priceNumeric: conversation.transaction.offer_price.amount,
            currency: conversation.transaction.offer_price.currency_code,
            url: conversation.transaction.item_url,
            photo: itemPhotoDto,
            title: conversation.transaction.item_title,
          }
        : undefined,
    education: conversation.education ? transformEducationDto(conversation.education) : null,
    transactionId: conversation.transaction?.id,
  }
}

export const transformNewEducationDto = (
  education: NewConversationEducationDto | null,
): NewConversationEducationModel | null => {
  if (!education) return null

  const { action, action_title, screen_title, type } = education

  return {
    action,
    actionTitle: action_title,
    screenTitle: screen_title,
    type,
  }
}
